<style lang="scss" scoped>
.page-wrap {
  padding: 8px 0 80px;
  font-family: 'Segoe UI', sans-serif;
}

.panel-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(13, 27, 62, 0.07);
  overflow: hidden;
}

/* ── Page header ── */
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  background: #eef2fb;
  border-bottom: 1px solid #dde4f5;

  .page-title {
    font-size: 13px;
    font-weight: 700;
    color: #389ad4;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .btn-back {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 32px;
    padding: 0 14px;
    background: #fff;
    color: #4a5568;
    border: 1.5px solid #dde2ec;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;

    &:hover { border-color: #389ad4; color: #389ad4; }
  }
}

/* ── Two-column layout ── */
.form-layout {
  display: grid;
  grid-template-columns: 1fr 300px;
  gap: 0;
}

.right-col {
  border-left: 1px solid #f0f3fa;
}

/* ── Section card ── */
.section-card {
  border-bottom: 1px solid #f0f3fa;
  padding: 20px 24px;

  &:last-child { border-bottom: none; }

  .section-title {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    color: #389ad4;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    gap: 7px;

    &::after {
      content: '';
      flex: 1;
      height: 1px;
      background: #e8edf5;
    }
  }
}

/* ── Fields ── */
.field-row {
  display: grid;
  gap: 14px;
  margin-bottom: 14px;

  &.cols-2 { grid-template-columns: 1fr 1fr; }
}

.field-group {
  display: flex;
  flex-direction: column;
  gap: 5px;

  label {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: #7a8499;

    .req { color: #e53e3e; margin-left: 2px; }
  }

  input[type="text"],
  input[type="email"],
  textarea,
  select {
    height: 38px;
    border: 1.5px solid #dde2ec;
    border-radius: 8px;
    padding: 0 12px;
    font-size: 13px;
    color: #0d1b3e;
    background: #fff;
    outline: none;
    transition: border-color 0.2s, box-shadow 0.2s;
    font-family: inherit;

    &::placeholder { color: #b0bac9; }
    &:focus { border-color: #389ad4; box-shadow: 0 0 0 3px rgba(56,154,212,0.1); }
    &.is-error { border-color: #e53e3e; }
    &:disabled { background: #f7f9fc; color: #a0aab8; cursor: not-allowed; }
  }

  textarea { height: auto; padding: 10px 12px; resize: vertical; }

  .field-error { font-size: 11px; color: #e53e3e; margin-top: 2px; }
}

/* ── Slug pill ── */
.slug-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #eef2fb;
  border: 1.5px solid #c5d4f0;
  border-radius: 8px;
  padding: 0 12px;
  height: 38px;
  font-size: 13px;
  font-family: monospace;
  color: #185FA5;
  font-weight: 600;
}

/* ── Toggle switch ── */
.toggle-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;

  .toggle-label {
    font-size: 13px;
    color: #4a5568;
    font-weight: 500;
  }
}

.switch-wrap {
  position: relative;
  display: inline-block;
  width: 38px;
  height: 22px;
  flex-shrink: 0;

  input { opacity: 0; width: 0; height: 0; }

  .slider {
    position: absolute;
    inset: 0;
    background: #cbd5e0;
    border-radius: 22px;
    cursor: pointer;
    transition: background 0.2s;

    &::before {
      content: '';
      position: absolute;
      width: 16px;
      height: 16px;
      left: 3px;
      top: 3px;
      background: #fff;
      border-radius: 50%;
      transition: transform 0.2s;
    }
  }

  input:checked + .slider { background: #389ad4; }
  input:checked + .slider::before { transform: translateX(16px); }
}

/* ── Media upload ── */
.media-block {
  margin-bottom: 18px;

  .media-label {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: #7a8499;
    margin-bottom: 8px;
  }

  .current-image {
    width: 100%;
    max-height: 120px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    background-color: #f0f4fa;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    margin-bottom: 8px;
  }

  canvas {
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    width: 100%;
    display: block;
    margin-bottom: 8px;
  }

  .upload-btn {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    height: 34px;
    padding: 0 14px;
    background: #eef2fb;
    color: #185FA5;
    border: 1.5px solid #c5d4f0;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;

    &:hover { background: #389ad4; color: #fff; border-color: #389ad4; }

    input[type="file"] { display: none; }
  }
}

/* ── Footer ── */
.form-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 24px;
  background: #fff;
  border-top: 1px solid #eef0f8;
  border-radius: 0 0 12px 12px;

  .btn-cancel {
    height: 36px;
    padding: 0 18px;
    background: #fff;
    color: #4a5568;
    border: 1.5px solid #dde2ec;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    display: inline-flex;
    align-items: center;
    gap: 6px;

    &:hover { border-color: #389ad4; color: #389ad4; }
  }

  .btn-update {
    height: 36px;
    padding: 0 24px;
    background: #389ad4;
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: opacity 0.2s;

    &:hover { opacity: 0.9; }
  }
}
</style>

<template>
  <div class="page-wrap">
    <div class="panel-card">

      <!-- Header -->
      <div class="page-header">
        <span class="page-title">
          <i :class="$route.name === 'admin.serviceprovider.edit' ? 'fa fa-building' : 'fa fa-map-marker'"></i>
          {{ $route.name === 'admin.serviceprovider.edit' ? 'Edit Service Provider' : 'Update Location' }}
        </span>
        <button class="btn-back" @click="goBack()">
          <i class="fa fa-arrow-left"></i> Back
        </button>
      </div>

      <div class="form-layout">

        <!-- ── Left: form fields ── -->
        <div>

          <!-- Service Provider selector (admin, location edit only) -->
          <div class="section-card" v-if="currentUser.u.is_admin && $route.name !== 'admin.serviceprovider.edit'">
            <div class="section-title"><i class="fa fa-building-o"></i> Service Provider</div>
            <div class="field-group">
              <label>Service Provider <span class="req">*</span></label>
              <select v-model="service_provider" disabled :class="errors['service_provider'] ? 'is-error' : ''">
                <option value="">Select a service provider…</option>
                <option v-for="(item, i) in getserviceProviders" :key="i" :value="item.id">{{ item.name }}</option>
              </select>
              <span class="field-error" v-if="errors['service_provider']">{{ errors['service_provider'][0] }}</span>
            </div>
          </div>

          <!-- Basic Info -->
          <div class="section-card">
            <div class="section-title"><i class="fa fa-info-circle"></i> Basic Information</div>

            <div class="field-row cols-2">
              <div class="field-group">
                <label>Code</label>
                <span class="slug-pill"><i class="fa fa-tag" style="font-size:11px;opacity:0.6;"></i> {{ slug }}</span>
              </div>
              <div class="field-group">
                <label>Name <span class="req">*</span></label>
                <input type="text" v-model="formData.name" :class="errors['name'] ? 'is-error' : ''" placeholder="Provider name" />
                <span class="field-error" v-if="errors['name']">{{ errors['name'][0] }}</span>
              </div>
            </div>

            <div class="field-group" style="margin-bottom:14px;">
              <label>Description <span class="req">*</span></label>
              <textarea rows="2" v-model="formData.description" :class="errors['description'] ? 'is-error' : ''"></textarea>
              <span class="field-error" v-if="errors['description']">{{ errors['description'][0] }}</span>
            </div>

            <div class="field-row cols-2" v-if="$route.name !== 'admin.serviceprovider.edit'">
              <div class="field-group">
                <label>QuickBook Display Name <span class="req">*</span></label>
                <input type="text" v-model="formData.quickbook_display_name" :class="errors['quickbook_display_name'] ? 'is-error' : ''" />
                <span class="field-error" v-if="errors['quickbook_display_name']">{{ errors['quickbook_display_name'][0] }}</span>
              </div>
              <div class="field-group">
                <label>County</label>
                <select v-model="formData.county" :class="errors['county'] ? 'is-error' : ''">
                  <option value="">Select county…</option>
                  <option value="Alachua">Alachua</option>
                  <option value="Baker">Baker</option>
                  <option value="Bay">Bay</option>
                  <option value="Bradford">Bradford</option>
                  <option value="Brevard">Brevard</option>
                  <option value="Broward">Broward</option>
                  <option value="Calhoun">Calhoun</option>
                  <option value="Charlotte">Charlotte</option>
                  <option value="Citrus">Citrus</option>
                  <option value="Clay">Clay</option>
                  <option value="Collier">Collier</option>
                  <option value="Columbia">Columbia</option>
                  <option value="Desoto">Desoto</option>
                  <option value="Dixie">Dixie</option>
                  <option value="Duval">Duval</option>
                  <option value="Escambia">Escambia</option>
                  <option value="Flagler">Flagler</option>
                  <option value="Franklin">Franklin</option>
                  <option value="Gadsden">Gadsden</option>
                  <option value="Georgia">Georgia</option>
                  <option value="Gilchrist">Gilchrist</option>
                  <option value="Glades">Glades</option>
                  <option value="Gulf">Gulf</option>
                  <option value="Hamilton">Hamilton</option>
                  <option value="Hardee">Hardee</option>
                  <option value="Hendry">Hendry</option>
                  <option value="Hernando">Hernando</option>
                  <option value="Highlands">Highlands</option>
                  <option value="Hillsborough">Hillsborough</option>
                  <option value="Holmes">Holmes</option>
                  <option value="Indian River">Indian River</option>
                  <option value="Jackson">Jackson</option>
                  <option value="Jefferson">Jefferson</option>
                  <option value="Lafayette">Lafayette</option>
                  <option value="Lake">Lake</option>
                  <option value="Lee">Lee</option>
                  <option value="Leon">Leon</option>
                  <option value="Levy">Levy</option>
                  <option value="Liberty">Liberty</option>
                  <option value="Madison">Madison</option>
                  <option value="Manatee">Manatee</option>
                  <option value="Marion">Marion</option>
                  <option value="Martin">Martin</option>
                  <option value="Miami‐Dade">Miami‐Dade</option>
                  <option value="Monroe">Monroe</option>
                  <option value="Nassau">Nassau</option>
                  <option value="Okaloosa">Okaloosa</option>
                  <option value="Okeechobee">Okeechobee</option>
                  <option value="Orange">Orange</option>
                  <option value="Osceola">Osceola</option>
                  <option value="Palm Beach">Palm Beach</option>
                  <option value="Pasco">Pasco</option>
                  <option value="Pinellas">Pinellas</option>
                  <option value="Polk">Polk</option>
                  <option value="Putnam">Putnam</option>
                  <option value="Santa Rosa">Santa Rosa</option>
                  <option value="Sarasota">Sarasota</option>
                  <option value="Seminole">Seminole</option>
                  <option value="St. Johns">St. Johns</option>
                  <option value="St. Lucie">St. Lucie</option>
                  <option value="Sumter">Sumter</option>
                  <option value="Suwannee">Suwannee</option>
                  <option value="Taylor">Taylor</option>
                  <option value="Union">Union</option>
                  <option value="Volusia">Volusia</option>
                  <option value="Wakulla">Wakulla</option>
                  <option value="Walton">Walton</option>
                  <option value="Washington">Washington</option>
                  <option value="Other States">Other States</option>
                </select>
                <span class="field-error" v-if="errors['county']">{{ errors['county'][0] }}</span>
              </div>
            </div>
          </div>

          <!-- Address -->
          <div class="section-card">
            <div class="section-title"><i class="fa fa-map-marker"></i> Address</div>

            <div class="field-row cols-2">
              <div class="field-group">
                <label>Address Line 1 <span class="req">*</span></label>
                <input type="text" v-model="formData.address" :class="errors['address'] ? 'is-error' : ''" />
                <span class="field-error" v-if="errors['address']">{{ errors['address'][0] }}</span>
              </div>
              <div class="field-group">
                <label>Address Line 2</label>
                <input type="text" v-model="formData.address2" />
              </div>
            </div>

            <div class="field-row cols-2">
              <div class="field-group">
                <label>State <span class="req">*</span></label>
                <input type="text" v-model="formData.state" :class="errors['state'] ? 'is-error' : ''" />
                <span class="field-error" v-if="errors['state']">{{ errors['state'][0] }}</span>
              </div>
              <div class="field-group">
                <label>City <span class="req">*</span></label>
                <input type="text" v-model="formData.city_name" :class="errors['city_name'] ? 'is-error' : ''" />
                <span class="field-error" v-if="errors['city_name']">{{ errors['city_name'][0] }}</span>
              </div>
            </div>

            <div class="field-row cols-2">
              <div class="field-group">
                <label>Zip Code <span class="req">*</span></label>
                <input type="text" v-mask="'#####'" v-model="formData.zipcode" :class="errors['zipcode'] ? 'is-error' : ''" />
                <span class="field-error" v-if="errors['zipcode']">{{ errors['zipcode'][0] }}</span>
              </div>
              <div class="field-group">
                <label>Timezone <span class="req">*</span></label>
                <select v-model="formData.client_timezone" :class="errors['client_timezone'] ? 'is-error' : ''">
                  <option value="">Select timezone…</option>
                  <option v-for="(tz, i) in timeZones" :key="i" :value="tz">{{ tz }}</option>
                </select>
                <span class="field-error" v-if="errors['client_timezone']">{{ errors['client_timezone'][0] }}</span>
              </div>
            </div>
          </div>

          <!-- Contact & Payment -->
          <div class="section-card">
            <div class="section-title"><i class="fa fa-phone"></i> Contact &amp; Payment</div>

            <div class="field-row cols-2">
              <div class="field-group">
                <label>Contact Number</label>
                <input type="text" v-mask="'(###)-###-####'" v-model="formData.phone_number" :class="errors['phone_number'] ? 'is-error' : ''" />
                <span class="field-error" v-if="errors['phone_number']">{{ errors['phone_number'][0] }}</span>
              </div>
              <div class="field-group">
                <label>Show Contact (for email)</label>
                <input type="text" v-mask="'(###)-###-####'" v-model="formData.show_contact" />
              </div>
            </div>

            <div class="field-group" v-if="$route.name === 'admin.serviceprovider.edit'">
              <label>Payment Method</label>
              <select v-model="formData.payment_method" :class="errors['payment_method'] ? 'is-error' : ''">
                <option value="">Select payment method…</option>
                <option value="cardpointe">CardPointe</option>
                <option value="heartland">Heartland</option>
              </select>
              <span class="field-error" v-if="errors['payment_method']">{{ errors['payment_method'][0] }}</span>
            </div>
          </div>

          <!-- Map & Online Info -->
          <div class="section-card">
            <div class="section-title"><i class="fa fa-map"></i> Location &amp; Online</div>

            <keep-alive>
              <GoogleMap
                ref="map"
                @getFullAddress="setFullAddress"
                @dragPointer="setLocation"
                @onSearchClick="setLocation"
              />
            </keep-alive>

            <div style="margin-top:16px;">
              <div class="field-group" style="margin-bottom:14px;">
                <label>Google Business URL</label>
                <input type="text" v-model="formData.google_business_url" :class="errors['google_business_url'] ? 'is-error' : ''" placeholder="https://…" />
                <span class="field-error" v-if="errors['google_business_url']">{{ errors['google_business_url'][0] }}</span>
              </div>

              <div class="field-row cols-2">
                <div class="field-group">
                  <label>Notification Email <span class="req">*</span></label>
                  <input type="text" v-model="formData.notification_email" :class="errors['notification_email'] ? 'is-error' : ''" />
                  <span class="field-error" v-if="errors['notification_email']">{{ errors['notification_email'][0] }}</span>
                </div>
                <div class="field-group">
                  <label>Display Name</label>
                  <input type="text" v-model="formData.display_name" :class="errors['display_name'] ? 'is-error' : ''" />
                  <span class="field-error" v-if="errors['display_name']">{{ errors['display_name'][0] }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Support Info (SP edit only) -->
          <div class="section-card" v-if="$route.name === 'admin.serviceprovider.edit'">
            <div class="section-title"><i class="fa fa-life-ring"></i> Support Info</div>
            <supporteditor
              v-model="formData.support_info"
              api-key="no-api-key"
              :init="{
                license_key: 'gpl',
                height: 200,
                menubar: false,
                plugins: ['advlist autolink lists link image charmap print preview anchor','searchreplace visualblocks code fullscreen','insertdatetime media table paste code help wordcount'],
                toolbar: 'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help'
              }"
              tinymce-script-src="/tinymce/js/tinymce/tinymce.min.js"
            />
          </div>

        </div>

        <!-- ── Right: media + settings ── -->
        <div class="right-col">

          <!-- Images -->
          <div class="section-card">
            <div class="section-title"><i class="fa fa-image"></i> Media</div>

            <!-- Provider Image -->
            <div class="media-block">
              <div class="media-label">Provider Image</div>
              <div
                v-if="image_place && !showImage"
                class="current-image"
                :style="{ backgroundImage: 'url(' + image_place + ')', height: '100px' }"
              ></div>
              <canvas v-if="showImage" id="imageCanvas" ref="imageCanvas"></canvas>
              <label class="upload-btn">
                <input type="file" @change="updateCanvasImage($event, 1)" hidden />
                <i class="fa fa-upload"></i> Upload Image
              </label>
              <span class="field-error" v-if="errors['image']" style="display:block; margin-top:4px;">{{ errors['image'][0] }}</span>
            </div>

            <!-- Favicon / Icon (non-SP users only) -->
            <div class="media-block" v-if="!currentUser.u.is_service_provider">
              <div class="media-label">Favicon / Icon</div>
              <div
                v-if="image_icon && !showIcon"
                class="current-image"
                :style="{ backgroundImage: 'url(' + image_icon + ')', height: '80px' }"
              ></div>
              <canvas v-if="showIcon" id="iconcanvas" ref="iconcanvas"></canvas>
              <label class="upload-btn">
                <input type="file" @change="updateCanvasImage($event, 2)" hidden />
                <i class="fa fa-upload"></i> Upload Icon
              </label>
            </div>
          </div>

          <!-- Settings toggles -->
          <div class="section-card">
            <div class="section-title"><i class="fa fa-sliders"></i> Settings</div>

            <div class="toggle-row">
              <label class="switch-wrap">
                <input type="checkbox" v-model="formData.is_active" />
                <span class="slider"></span>
              </label>
              <span class="toggle-label">Active</span>
            </div>

            <div class="toggle-row" v-if="$route.name === 'client.location.edit'">
              <label class="switch-wrap">
                <input type="checkbox" v-model="formData.is_offline_mode" id="offline-switch" />
                <span class="slider"></span>
              </label>
              <span class="toggle-label">Offline Mode</span>
            </div>

            <div class="toggle-row" v-if="$route.name === 'admin.serviceprovider.edit'">
              <label class="switch-wrap">
                <input type="checkbox" v-model="formData.show_store_forward" id="switch-store" />
                <span class="slider"></span>
              </label>
              <span class="toggle-label">Show Store Forward</span>
            </div>

            <div class="toggle-row">
              <label class="switch-wrap">
                <input type="checkbox" v-model="formData.review_enabled" id="feedback-switch" />
                <span class="slider"></span>
              </label>
              <span class="toggle-label">Allow Feedback Survey</span>
            </div>

            <div class="toggle-row" v-if="$route.name !== 'admin.serviceprovider.edit'">
              <label class="switch-wrap">
                <input type="checkbox" v-model="formData.enable_on_site_payment" id="switch-on-site-payment" />
                <span class="slider"></span>
              </label>
              <span class="toggle-label">On Site Payment</span>
            </div>

            <div class="toggle-row" v-if="$route.name !== 'admin.serviceprovider.edit'">
              <label class="switch-wrap">
                <input type="checkbox" v-model="formData.is_mobile_fingerprinting" id="switch-mobile" />
                <span class="slider"></span>
              </label>
              <span class="toggle-label">Mobile Location</span>
            </div>

            <div class="toggle-row" v-if="$route.name !== 'admin.serviceprovider.edit'">
              <label class="switch-wrap">
                <input type="checkbox" v-model="formData.card_scan" id="switch-card-scan" />
                <span class="slider"></span>
              </label>
              <span class="toggle-label">Card Scan</span>
            </div>

            <div class="toggle-row" v-if="$route.name !== 'admin.serviceprovider.edit'">
              <label class="switch-wrap">
                <input type="checkbox" v-model="formData.photo_enabled" id="switch-photo" />
                <span class="slider"></span>
              </label>
              <span class="toggle-label">Photo Enabled</span>
            </div>
          </div>

        </div>
      </div>

      <!-- Footer -->
      <div class="form-footer">
        <button class="btn-cancel" @click="goBack()">
          <i class="fa fa-arrow-left"></i> Back
        </button>
        <button class="btn-update" ref="kt_update_service" @click="update('kt_update_service')">
          <i class="fa fa-check"></i> Update
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import GoogleMap from "@/components/GoogleMap.vue";
import { SET_BREADCRUMB } from "@/core/services/store/mutations.type";
import {
  GET_B_LOCATION_DATA,
  UPDATE_B_LOCATION,
  GET_SERVICE_PROVIDER_LIST
} from "@/core/services/store/actions.type";
import Editor from "@tinymce/tinymce-vue";
import { mapGetters } from "vuex";

export default {
  components: {
    GoogleMap,
    supporteditor: Editor
  },
  computed: {
    ...mapGetters([
      "getAspectheight",
      "getAspectwidth",
      "getCanvasheight",
      "currentUser",
      "getserviceProviders"
    ])
  },
  data() {
    return {
      breadCrumbs: [
        { id: 1, title: "Dashboard", route: "client.dashboard" },
        { id: 2, title: "Locations", route: "client.location" },
        { id: 3, title: "Update Location", route: "" }
      ],
      formData: {
        name: "",
        description: "",
        address: "",
        city_name: "",
        zipcode: "",
        long: "",
        lat: "",
        client_timezone: "",
        is_active: false,
        enable_on_site_payment: false,
        address2: "",
        state: "",
        notification_email: "",
        google_business_url: "",
        display_name: "",
        phone_number: "",
        show_contact: "",
        fav_icon: "",
        payment_method: "",
        show_store_forward: false,
        card_scan: false,
        county: "",
        is_mobile_fingerprinting: false,
        photo_enabled: false,
        support_info: "",
        quickbook_display_name: "",
        review_enabled: false,
        is_offline_mode: false
      },
      timeZones: [],
      showImage: false,
      showIcon: false,
      image_base64: "",
      fav_image_base64: "",
      image_crop_base64: "",
      loading_data: true,
      loadingData: false,
      errors: [],
      image_place: "",
      image_icon: "",
      slug: "",
      supporteditor: Editor,
      service_provider: ""
    };
  },
  created() {
    if (this.currentUser.u.is_admin) this.getServiceProvider();
    this.timeZones = this.$moment.tz.names();
    if (this.$route.name === "admin.serviceprovider.edit") {
      this.breadCrumbs[1].title = "Service Provider";
      this.breadCrumbs[1].route = "admin.serviceprovider.index";
      this.breadCrumbs[2].title = "Update Service Provider";
    }
    this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);
    this.getSingleLocation(this.$route.params.id);
  },
  methods: {
    setFullAddress(data) {
      this.formData.address = data;
    },
    setLocation(location) {
      this.formData.long = location.lng;
      this.formData.lat = location.lat;
      this.formData.city_name = location.city.long_name;
      this.formData.address = location.formatted_address;
      this.formData.zipcode = location.postal_code.long_name;
      const state = location.state.short_name.toUpperCase();
      this.formData.state = state === undefined ? "" : state;
    },
    goBack() {
      if (this.$route.name === "admin.serviceprovider.edit") {
        this.$router.push({ name: "admin.serviceprovider.index" });
      } else {
        this.$router.push({ name: "client.location", params: { client_slug: this.$route.params.client_slug } });
      }
    },
    getSingleLocation(id) {
      this.$store.dispatch(GET_B_LOCATION_DATA, id).then(data => {
        if (data.length === 0) return this.goBack();
        this.formData.name = data.name;
        this.formData.description = data.description;
        this.formData.address = data.address;
        this.formData.city_name = data.city_name;
        this.formData.zipcode = data.zipcode;
        this.formData.long = data.long;
        this.formData.lat = data.lat;
        this.formData.phone_number = data.phone_number;
        this.formData.show_contact = data.show_contact;
        this.formData.support_info = data.support_info;
        this.formData.payment_method = data.payment_method == null ? "" : data.payment_method;
        this.$refs.map.defaultMarkerPosition(Number(data.lat), Number(data.long));
        this.formData.client_timezone = data.client_timezone;
        this.image_place = data.image;
        this.image_icon = data.fav_icon;
        this.service_provider = data.client;
        this.formData.is_active = data.is_active;
        this.formData.review_enabled = data.review_enabled;
        this.formData.is_offline_mode = data.is_offline_mode;
        this.formData.google_business_url = data.google_business_url;
        this.formData.show_store_forward = data.show_store_forward;
        this.slug = data.slug;
        this.formData.address2 = data.address2;
        this.formData.state = data.state;
        this.formData.enable_on_site_payment = data.enable_on_site_payment;
        this.formData.is_mobile_fingerprinting = data.is_mobile_fingerprinting;
        this.formData.card_scan = data.card_scan;
        this.formData.notification_email = data.notification_email;
        this.formData.photo_enabled = data.photo_enabled;
        this.formData.county = data.county;
        this.formData.display_name = data.display_name;
        this.formData.quickbook_display_name = data.quickbook_display_name;
      });
    },
    closeBtnLoad(ref) {
      const btn = this.$refs[ref];
      if (btn) {
        btn.classList.remove("spinner", "spinner-light", "spinner-right");
        btn.disabled = false;
      }
    },
    loadingButton(ref) {
      const btn = this.$refs[ref];
      if (btn) {
        btn.disabled = true;
        btn.classList.add("spinner", "spinner-light", "spinner-right");
      }
    },
    update(ref) {
      this.formData.notification_email = this.formData.notification_email
        ? this.formData.notification_email.replace(" ", "")
        : "";
      this.formData.image = this.image_base64 !== "" ? this.image_base64 : "none";
      this.formData.fav_icon = this.fav_image_base64 !== "" ? this.fav_image_base64 : "none";
      this.loadingButton(ref);
      this.$store.dispatch(UPDATE_B_LOCATION, {
        id: this.$route.params.id,
        data: this.formData,
        for_api: this.$route.name === "admin.serviceprovider.edit" ? "sp" : "location"
      }).then(data => {
        this.$toastr.s(data.msg);
        this.closeBtnLoad(ref);
        this.goBack();
      }).catch(err => {
        this.errors = err;
        this.closeBtnLoad(ref);
      });
    },
    updateCanvasImage(e, val) {
      if (val === 1) { this.showImage = true; this.image_place = ""; }
      else { this.showIcon = true; this.image_icon = ""; }
      const reader = new FileReader();
      reader.onload = ev => {
        const img = new Image();
        img.onload = () => this.drawCanvasImage(img, val);
        img.src = ev.target.result;
      };
      reader.readAsDataURL(e.target.files[0]);
    },
    drawCanvasImage(imageObj, val) {
      const canvas = val === 1 ? this.$refs.imageCanvas : this.$refs.iconcanvas;
      canvas.width = imageObj.width;
      canvas.height = imageObj.height;
      canvas.getContext("2d").drawImage(imageObj, 0, 0);
      const base64 = canvas.toDataURL("image/png");
      if (val === 1) this.image_base64 = base64;
      else this.fav_image_base64 = base64;
    },
    getServiceProvider() {
      this.loadingData = true;
      this.$store.dispatch(GET_SERVICE_PROVIDER_LIST)
        .then(res => { if (res.code == 200) this.url = res.url; this.loadingData = false; })
        .catch(() => { this.loadingData = false; });
    }
  }
};
</script>
